import { VueNodeViewRenderer } from '@tiptap/vue-2'

import TipTapBucketFile from './TipTapBucketFile.vue'
import { createBucketFileExtension } from '@learnics/models/src/utils/tiptap/createBucketFileExtension.mjs'

export const BucketFile = createBucketFileExtension(
  VueNodeViewRenderer(TipTapBucketFile),
)
